import { createContext } from 'react';

export const SiteContextState = createContext<any>({});
